import angular from 'angular';
// Missing dependencies - commented out until installed
// import 'angular-breadcrumb';
// import 'ng-table';
import './superuserServices';
import './superuserDirectives';
import './clients/clientsControllers';
import './roles/rolesControllers';
import './packages/packagesControllers';
import {accessLevels} from '../services/accessLevels';

/**
 * @ngdoc overview
 * @name adminModule
 * @description
 * # adminModule
 * Module for managing the administration of: users, places, beacons and clients.
 */
const superuserModule = angular.module('superuserModule', [
    // 'ncy-angular-breadcrumb', // Commented out until angular-breadcrumb is installed
    // 'ngTable', // Commented out until ng-table is installed
    'superuserModule.clientsControllers',
    'superuserModule.packagesControllers',
    'superuserModule.rolesControllers',
    'superuserModule.superuserDirectives',
    'superuserModule.superuserServices'
]);

superuserModule.config(['$stateProvider', function ($stateProvider) {
    'use strict';

    $stateProvider
        .state('appsoup.admin.roles', {
            url: '/roles',
            templateUrl: 'views/superuser/roles/roles.tpl.html',
            controller: 'RolesListController',
            ncyBreadcrumb: {
                label: 'MODULES.ROLES.TITLE'
            },
            accessLevel: accessLevels.superuser
        })
        .state('appsoup.admin.newRole', {
            url: '/roles/new',
            templateUrl: 'views/superuser/roles/role.tpl.html',
            controller: 'RolePageController',
            ncyBreadcrumb: {
                label: 'MODULES.ROLES.NEW_ROLE',
                parent: 'appsoup.admin.roles'
            },
            menuActive: 'appsoup.admin.roles',
            accessLevel: accessLevels.superuser
        })
        .state('appsoup.admin.editRole', {
            url: '/roles/edit/:roleId',
            templateUrl: 'views/superuser/roles/role.tpl.html',
            controller: 'RolePageController',
            ncyBreadcrumb: {
                label: 'MODULES.ROLES.EDIT_ROLE',
                parent: 'appsoup.admin.roles'
            },
            menuActive: 'appsoup.admin.roles',
            accessLevel: accessLevels.superuser
        })
        .state('appsoup.admin.clients', {
            url: '/clients',
            templateUrl: 'views/superuser/clients/clients.tpl.html',
            controller: 'ClientsListController',
            ncyBreadcrumb: {
                label: 'MODULES.CLIENTS.TITLE'
            },
            accessLevel: accessLevels.superuser
        })
        .state('appsoup.admin.editClient', {
            url: '/client/:clientId',
            controller: 'ClientPageController',
            templateUrl: 'views/superuser/clients/client.tpl.html',
            ncyBreadcrumb: {
                label: '{{ client.name }}',
                parent: 'appsoup.admin.clients'
            },
            menuActive: 'appsoup.admin.clients',
            accessLevel: accessLevels.superuser
        })
        .state('appsoup.admin.newClient', {
            url: '/clients/new',
            controller: 'ClientPageController',
            templateUrl: 'views/superuser/clients/client.tpl.html',
            ncyBreadcrumb: {
                label: 'MODULES.CLIENTS.NEW_CLIENT',
                parent: 'appsoup.admin.clients'
            },
            menuActive: 'appsoup.admin.clients',
            accessLevel: accessLevels.superuser
        })
        .state('appsoup.admin.packages', {
            url: '/packages',
            templateUrl: 'views/superuser/packages/packages.tpl.html',
            controller: 'PackagesListController',
            ncyBreadcrumb: {
                label: 'MODULES.PACKAGES.TITLE'
            },
            accessLevel: accessLevels.superuser
        })
        .state('appsoup.admin.newPackage', {
            url: '/packages/new',
            templateUrl: 'views/superuser/packages/package.tpl.html',
            controller: 'PackagePageController',
            ncyBreadcrumb: {
                label: 'MODULES.PACKAGES.NEW_PACKAGE',
                parent: 'appsoup.admin.packages'
            },
            menuActive: 'appsoup.admin.packages',
            accessLevel: accessLevels.superuser
        })
        .state('appsoup.admin.editPackage', {
            url: '/packages/edit/:packageId',
            templateUrl: 'views/superuser/packages/package.tpl.html',
            controller: 'PackagePageController',
            ncyBreadcrumb: {
                label: 'MODULES.PACKAGES.EDIT_PACKAGE',
                parent: 'appsoup.admin.packages'
            },
            menuActive: 'appsoup.admin.packages',
            accessLevel: accessLevels.superuser
        });
}]);

export default superuserModule;
